<template>
  <net-benefits-header
    v-if="showNBHeader"
    :title="accountType"
  />
  <pvd-header
    v-else
    :title="accountType"
    hide-login="true"
  />
</template>

<script>
import NetBenefitsHeader from './NetBenefitsHeader.vue';
import utility from '../mixins/utility';

export default {
  name: 'SiteHeader',
  components: {
    NetBenefitsHeader,
  },
  mixins: [utility],
  props: {
    accountType: {
      type: String,
      default: '',
    },
    nbHeader: {
      type: String,
      default: 'false',
    },
  },
  computed: {
    showNBHeader() {
      return this.isNetBenefits();
    },
  },
};
</script>

<style scoped>

</style>
